import React, {useEffect, useRef} from 'react';
import { AnodizingDecorationElement } from '../styles';
import { gsap } from "gsap";

const AnodizingDecorationIcon = ({ activeIndex }) => {

  const animateSvg = useRef(null);

  useEffect(() => {
    let valueTo = '106';
    switch(activeIndex) {
      case 0:
        valueTo = '106';
        break;
      case 1:
        valueTo = '212';
        break;
      case 2:
        valueTo = '316';
        break;
      case 3:
        valueTo = '421';
        break;
      case 4:
        valueTo = '550';
        break;
      default:
        valueTo = '106';
    }

    gsap.to(animateSvg.current, {x: valueTo, duration: 1})
  }, [activeIndex]);

  return(
    <AnodizingDecorationElement>
      <svg
        width="550"
        height="109"
        viewBox="0 0 550 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M526.834 17.5247H437.465V107.666H526.834V17.5247Z"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <path
          d="M421.588 17.5247H332.219V107.666H421.588V17.5247Z"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <path
          d="M316.242 17.5247H226.872V107.666H316.242V17.5247Z"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <path
          d="M210.995 17.5247H121.626V107.666H210.995V17.5247Z"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <path
          d="M105.65 17.5247H16.2803V107.666H105.65V17.5247Z"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <path
          d="M549.5 17.4236C549.4 9.46693 543.109 2.71891 535.22 2.21532C526.733 1.61102 519.543 8.15761 519.044 16.5171C518.844 19.74 518.045 22.963 516.747 26.1859C507.161 50.1565 476.306 55.9981 457.734 38.2719C450.644 31.5239 445.252 23.1644 444.153 15.4092C443.055 7.95618 436.764 2.21532 429.076 2.21532C420.987 2.21532 414.397 8.56048 413.798 16.6178C413.598 19.8408 412.799 23.0637 411.501 26.2866C401.915 50.2572 371.06 56.0988 352.487 38.3727C345.398 31.6246 340.006 23.2651 338.907 15.5099C337.809 8.05689 331.518 2.31604 323.829 2.31604C315.741 2.31604 309.151 8.6612 308.552 16.7185C308.352 19.9415 307.553 23.1644 306.255 26.3874C296.669 50.3579 265.814 56.1995 247.241 38.4734C240.152 31.7253 234.76 23.3658 233.661 15.6107C232.563 8.15761 226.272 2.41675 218.583 2.41675C210.495 2.41675 203.905 8.76191 203.306 16.8193C203.106 20.0422 202.307 23.2651 201.009 26.4881C191.423 50.4587 160.468 56.3002 142.095 38.3727C135.205 31.6246 130.112 23.4666 129.014 15.8121C128.016 8.35905 121.625 2.51747 113.836 2.51747C105.748 2.51747 99.1577 8.86263 98.5586 16.92C98.3589 19.6393 97.7598 22.4594 96.8611 25.078C86.3764 54.7895 43.9384 54.7895 33.4538 25.078C32.5551 22.3587 31.8561 19.6393 31.7562 16.92C30.9574 8.15761 23.8678 1.61102 15.2803 2.1146C7.39185 2.61819 1.10105 9.46693 1.00119 17.4236C0.901337 25.5816 7.09229 32.2289 14.9808 32.9339C31.7562 34.4447 48.5317 51.5666 49.73 68.5877C50.2292 76.645 56.9195 82.9902 65.0076 82.9902C73.0958 82.9902 79.6862 76.645 80.2853 68.5877C80.485 65.3647 81.2838 62.1418 82.5819 58.9189C92.1679 34.9483 123.123 29.1067 141.496 47.0343C148.386 53.7823 153.478 61.9404 154.577 69.5949C155.575 77.0479 161.966 82.8895 169.755 82.8895C177.843 82.8895 184.433 76.5443 185.032 68.487C185.232 65.264 186.031 62.0411 187.329 58.8182C196.915 34.8476 227.77 29.006 246.343 46.7321C253.432 53.4802 258.824 61.8397 259.923 69.5949C261.021 77.0479 267.312 82.7888 275.001 82.7888C283.089 82.7888 289.679 76.4436 290.278 68.3863C290.478 65.1633 291.277 61.9404 292.575 58.7174C302.161 34.7468 333.016 28.9053 351.589 46.6314C358.678 53.3795 364.071 61.7389 365.169 69.4941C366.267 76.9472 372.558 82.688 380.247 82.688C388.335 82.688 394.925 76.3429 395.525 68.2855C395.724 65.0626 396.523 61.8397 397.821 58.6167C407.407 34.6461 438.262 28.8046 456.835 46.5307C463.925 53.2787 469.317 61.6382 470.415 69.3934C471.513 76.8465 477.804 82.5873 485.493 82.5873C493.581 82.5873 500.172 76.2422 500.771 68.1848C501.969 51.2644 518.744 34.0418 535.52 32.5311C543.408 32.2289 549.599 25.5816 549.5 17.4236Z"
          fill="#222121"
          stroke="#222121"
          stroke-miterlimit="10"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="550"
          height="89"
        >
          <rect ref={animateSvg} x='0' width="550" height="89" fill="#C4C4C4">
          </rect>
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M549.5 17.4236C549.4 9.46693 543.109 2.71891 535.22 2.21532C526.733 1.61102 519.543 8.15761 519.044 16.5171C518.844 19.74 518.045 22.963 516.747 26.1859C507.161 50.1565 476.306 55.9981 457.734 38.2719C450.644 31.5239 445.252 23.1644 444.153 15.4092C443.055 7.95618 436.764 2.21532 429.076 2.21532C420.987 2.21532 414.397 8.56048 413.798 16.6178C413.598 19.8408 412.799 23.0637 411.501 26.2866C401.915 50.2572 371.06 56.0988 352.487 38.3727C345.398 31.6246 340.006 23.2651 338.907 15.5099C337.809 8.05689 331.518 2.31604 323.829 2.31604C315.741 2.31604 309.151 8.6612 308.552 16.7185C308.352 19.9415 307.553 23.1644 306.255 26.3874C296.669 50.3579 265.814 56.1995 247.241 38.4734C240.152 31.7253 234.76 23.3658 233.661 15.6107C232.563 8.15761 226.272 2.41675 218.583 2.41675C210.495 2.41675 203.905 8.76191 203.306 16.8193C203.106 20.0422 202.307 23.2651 201.009 26.4881C191.423 50.4587 160.468 56.3002 142.095 38.3727C135.205 31.6246 130.112 23.4666 129.014 15.8121C128.016 8.35905 121.625 2.51747 113.836 2.51747C105.748 2.51747 99.1577 8.86263 98.5586 16.92C98.3589 19.6393 97.7598 22.4594 96.8611 25.078C86.3764 54.7895 43.9384 54.7895 33.4538 25.078C32.5551 22.3587 31.8561 19.6393 31.7562 16.92C30.9574 8.15761 23.8678 1.61102 15.2803 2.1146C7.39185 2.61819 1.10105 9.46693 1.00119 17.4236C0.901337 25.5816 7.09229 32.2289 14.9808 32.9339C31.7562 34.4447 48.5317 51.5666 49.73 68.5877C50.2292 76.645 56.9195 82.9902 65.0076 82.9902C73.0958 82.9902 79.6862 76.645 80.2853 68.5877C80.485 65.3647 81.2838 62.1418 82.5819 58.9189C92.1679 34.9483 123.123 29.1067 141.496 47.0343C148.386 53.7823 153.478 61.9404 154.577 69.5949C155.575 77.0479 161.966 82.8895 169.755 82.8895C177.843 82.8895 184.433 76.5443 185.032 68.487C185.232 65.264 186.031 62.0411 187.329 58.8182C196.915 34.8476 227.77 29.006 246.343 46.7321C253.432 53.4802 258.824 61.8397 259.923 69.5949C261.021 77.0479 267.312 82.7888 275.001 82.7888C283.089 82.7888 289.679 76.4436 290.278 68.3863C290.478 65.1633 291.277 61.9404 292.575 58.7174C302.161 34.7468 333.016 28.9053 351.589 46.6314C358.678 53.3795 364.071 61.7389 365.169 69.4941C366.267 76.9472 372.558 82.688 380.247 82.688C388.335 82.688 394.925 76.3429 395.525 68.2855C395.724 65.0626 396.523 61.8397 397.821 58.6167C407.407 34.6461 438.262 28.8046 456.835 46.5307C463.925 53.2787 469.317 61.6382 470.415 69.3934C471.513 76.8465 477.804 82.5873 485.493 82.5873C493.581 82.5873 500.172 76.2422 500.771 68.1848C501.969 51.2644 518.744 34.0418 535.52 32.5311C543.408 32.2289 549.599 25.5816 549.5 17.4236Z"
            fill="#F0F0F0"
            stroke="#222121"
            stroke-miterlimit="10"
          />
        </g>
      </svg>
    </AnodizingDecorationElement>
  )
}

export default AnodizingDecorationIcon;